import {
  useContentShareState,
  useContentShareControls,
} from "amazon-chime-sdk-component-library-react";
import VideoUIControlsContentShare from "./VideoUIControlsContentShare";
import { VideoUIContainerBreakpoints } from "../../videoUI.types";

export type Props = {
  containerBreakpoints: VideoUIContainerBreakpoints;
};

export function VideoUIControlsContentShareContainer({
  containerBreakpoints,
}: Props) {
  const { isLocalUserSharing } = useContentShareState();

  const { toggleContentShare, togglePauseContentShare } =
    useContentShareControls();

  return (
    <VideoUIControlsContentShare
      isLocalUserSharing={isLocalUserSharing}
      onToggleContentShare={toggleContentShare}
      onTogglePauseContentShare={togglePauseContentShare}
      containerBreakpoints={containerBreakpoints}
    />
  );
}

export default VideoUIControlsContentShareContainer;
